import { parseMarkdown } from './text-parsing'
import { Dispatch, RefObject, SetStateAction } from 'react'
import { Notification } from '../models'

export const buildObjects = (data: string[][]) =>
  data.slice(1).reduce(
    (acc, [year, audioUrl, ...data]) => ({
      ...acc,
      [year]: {
        data: data.map(col => parseMarkdown(col)).flat(),
        audioUrl,
      },
    }),
    {} as {
      [year: string]: {
        data: ReturnType<typeof parseMarkdown>
        audioUrl: string
      }
    }
  )

export const parsePeople = (data: string[][]) =>
  data.slice(1).reduce(
    (acc, [name, shortName, description, years]) => [
      ...acc,
      {
        name: name.trim(),
        shortName: shortName.trim(),
        description,
        years: years.split(',').map(i => i.trim()),
      },
    ],
    [] as Array<{
      name: string
      shortName: string
      years: string[]
      description: string
    }>
  )

export const playStart = async (
  ref: RefObject<HTMLAudioElement>,
  value?: string | number,
  errorHandler?: (message: Error | string, type: Notification['type']) => void
) => {
  try {
    if (ref.current) {
      await ref.current.play()
    }
  } catch (err) {
    if (value && errorHandler && !(err as Error).message.includes('aborted')) {
      errorHandler(`${value}: ${(err as Error).message}`, 'error')
    }
  }
}

export const startHelpAnimation = (
  state: number[],
  setState: Dispatch<SetStateAction<number[]>>,
  makeHelpDone: () => void
) => {
  let i: number = -1

  const animate = () => {
    setState(() => {
      const nextState = [...state]
      nextState[Math.floor(i / 2)] = i % 2 ? 0 : 1
      return nextState
    })
  }

  let intervalId = setInterval(() => {
    if (i >= state.length * 2 - 1) {
      clearInterval(intervalId)
      makeHelpDone()
    } else {
      i++
      animate()
    }
  }, 1000)
}
